import { TranslationProvider } from '@hopin-team/provider-translation';
import { ReactIDProvider } from '@hopin-team/react-id';
import { createReactRouterApp } from '@slicesjs/react-router-app';
import React from 'react';

import packageJson from '../package.json';
import { Precall } from './Precall';

const defaultErrorHandler = (error: Error) =>
  console.error('Error creating Pre-Event-Check application', error);

const App = () => {
  return (
    <ReactIDProvider>
      <TranslationProvider
        supportedLocales={['en']}
        getLocale={(locale: string) => import(`./locales/${locale}.json`)}
        locale="en"
      >
        <Precall />
      </TranslationProvider>
    </ReactIDProvider>
  );
};
export const { mount } = createReactRouterApp(App, {
  packageName: packageJson.name,
  onError: defaultErrorHandler,
});
